module.exports = __webpack_public_path__ + "img/voice.3d3f2ac0.gif";